module.exports = __webpack_public_path__ + "img/birth.bdecc00a.svg";